module.exports = __webpack_public_path__ + "img/truck-tick.6d8c5ea1.svg";